var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[(_vm.$vuetify.breakpoint.mdAndUp)?_c('Sidebar',{attrs:{"items":_vm.navigationItems}}):_c('Mobile-Navigation',{attrs:{"items":_vm.navigationItems}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }